class ExpandOnce {
	constructor(el) {
		this.el = el
		this.el.addEventListener('click', this._triggerHandler.bind(this))
	}
	_triggerHandler(event) {
		this.el.remove();
	}
}

export default ExpandOnce
